import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eb35526"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mic-permission" }
const _hoisted_2 = {
  key: 0,
  class: "blocked-access"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Please allow access to your microphone for making a call online")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.blockedAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}